import { useCallback } from "react";

export const useServerFilterUsers = (
  { userStore, uiStore, setUsers, setPagination, searchTerm , i, type}
) => {
  const serverFilterUsers = useCallback(
    async ( searchStr, lastId, navId, type) => {
      const strSch = searchStr ?? searchTerm;
      const SearchString = strSch?.toLowerCase() ?? "";
      let filteredProjects = [];
      let searchbar = document.getElementById("searchbar");
      if (searchbar) {
        searchbar.disabled = true;
        searchbar.focus();
      }
      uiStore.setLoading(true);
      try {
        //(lastId, type, navId, lookupStrng)
        filteredProjects = await userStore.getUsers(lastId,type,navId, SearchString); 
        if (Object.keys(filteredProjects).includes("users") && Array.isArray(filteredProjects.users)) {
          setUsers(filteredProjects.users);
          setPagination({
            currentPage: filteredProjects?.pagination?.currentPage ?? 1,
            hasMore: filteredProjects?.pagination?.hasMore ?? false,
            nextCursor: filteredProjects?.pagination?.nextCursor ?? "",
            prevCursor: filteredProjects?.pagination?.prevCursor ?? "",
            pageSize: filteredProjects?.pagination?.pageSize ?? 8,
            totalPages: filteredProjects?.pagination?.totalPages ?? 0,
            totalUsers: filteredProjects?.pagination?.totalUsers ?? 0
          });
        } else {
          setUsers([]);
        }
      } catch (error) {
        setUsers([]);
      } finally {
        if (searchbar) {
          searchbar.disabled = false;
          searchbar.focus();
        }
        uiStore.setLoading(false);
      }
    },
    [searchTerm, userStore, uiStore, setUsers, setPagination, i, type]
  );
  return { serverFilterUsers };
};
